import React, { useState, useContext } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Pagetitle from "../Components/Pagetitle";
import { Helmet } from "react-helmet";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { postData } from "../Api";
import { SettingsContext } from "../SettingsContext";

function Contact() {
  const { settings } = useContext(SettingsContext);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState("success");
  const [modalMessage, setModalMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await postData("/contact", formData);

      if (response.success) {
        setModalType("success");
        setModalMessage("Message sent successfully!");
        setShowModal(true);

        setFormData({
          name: "",
          email: "",
          phone: "",
          message: "",
        });
      } else {
        setModalType("error");
        setModalMessage(response.message || "Failed to send message!");
        setShowModal(true);
      }
    } catch (error) {
      setModalType("error");
      setModalMessage("Something went wrong: " + error.message);
      setShowModal(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Contact | Color Kingdon - Premium Colouring Books</title>
        <meta
          name="description"
          content="Contact Color Kingdon for colouring book orders, support, wholesale inquiries, and collaborations. Sikar-based premium colouring books for kids & adults."
        />
        <meta
          name="keywords"
          content="contact Color Kingdon, colouring books contact, premium colouring books, kids colouring books, adult colouring books, Sikar colouring books, wholesale colouring books"
        />
      </Helmet>

      <main className="container-fluid">
        <Header />
        <Pagetitle />

        <section className="row px-sm-5">
          <div className="col">
            <div className="row py-5">
              {/* Contact Form */}
              <div className="col-lg-6 mb-md-0 mb-4">
                <h4 className="fw-bold">Drop Us Message</h4>

                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label">Your Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      placeholder="Your Full Name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Email Address</label>
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      placeholder="Your Email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Phone</label>
                    <input
                      type="tel"
                      className="form-control"
                      name="phone"
                      placeholder="Your Contact Number"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Message</label>
                    <textarea
                      className="form-control"
                      rows="4"
                      name="message"
                      placeholder="Your message here..."
                      value={formData.message}
                      onChange={handleChange}
                      required
                    ></textarea>
                  </div>

                  <button
                    type="submit"
                    className="btn-style1"
                    disabled={loading}
                  >
                    {loading ? "Submitting..." : "Submit →"}
                  </button>
                </form>
              </div>

              {/* CONTACT INFO */}
              <div className="col-lg-6 mb-md-0 mb-4">
                <h4 className="fw-bold">Get In Touch With Us!</h4>
                <p>
                  We’re here to help! Whether you have a question, need support,
                  or want to collaborate.
                </p>
                <div className="contact-info mt-3">
                  <p>
                    <i className="fa-solid fa-location-dot pe-2 text-success"></i>
                    {settings?.address}
                  </p>
                  <p>
                    <i className="fa-solid fa-phone pe-2 text-success"></i>
                    <strong>Phone:</strong> {settings?.contact}
                  </p>
                  <p>
                    <i className="fa-solid fa-mobile-screen pe-2 text-success"></i>
                    <strong>Mobile:</strong> {settings?.mobile}
                  </p>
                  <p>
                    <i className="fa-solid fa-envelope pe-2 text-success"></i>
                    <strong>Email:</strong> {settings?.email}
                  </p>
                  {/* Map */}
                  <div className="map-responsive mt-4">
                    <iframe
                      src={settings?.map}
                      width="100%"
                      height="300"
                      style={{ border: 0 }}
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Company Location"
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </main>

      {/* Modal */}
      <div
        className={`modal fade ${showModal ? "show d-block" : ""}`}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content py-md-5 py-3 rounded-5">
            <div className="modal-body text-center">
              {modalType === "success" ? (
                <FaCheckCircle size={70} color="green" />
              ) : (
                <FaTimesCircle size={70} color="red" />
              )}
              <h4 className="py-md-3 py-2">{modalMessage}</h4>
            </div>
            <div className="text-center pb-3">
              <button className="btn-style1" onClick={closeModal}>
                OK
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contact;
